/* ---------- HIDE TOOLTIP ---------- */
document.addEventListener("mouseover", function () {
  document.querySelectorAll(".boost-sd__tooltip-content").forEach(el => {
    el.style.display = "none";
  });
});


/* ---------- BOOST COMPONENT ---------- */
window.boostSDComponents = window.boostSDComponents || {};

window.boostSDComponents.SearchProductItem = {
  apply: function () {
    return {
      afterRender: function (element) {

        const el = element.getElement();

        // REMOVE TOP ADD TO CART
        const topBtn = el.querySelector(".boost-sd__product-image-column button");
        if (topBtn) topBtn.remove();

        // TITLE
        const title = el.querySelector(".boost-sd__product-title");

        // DESCRIPTION (FINAL STABLE)
          if (!el.querySelector(".custom-desc")) {

            const data = element.getParams()?.props?.product;

            if (data && data.title) {

              const desc = document.createElement("div");
              desc.className = "custom-desc";

              let text = data.title.trim();
              desc.innerText = text.length > 60 ? text.slice(0, 60) + "..." : text;

              desc.style.fontSize = "13px";
              desc.style.color = "#666";
              desc.style.margin = "6px 0";

              const container = el.querySelector(".boost-sd__product-info-wrapper") 
                            || el.querySelector(".boost-sd__product-info");

              if (container) {
                container.appendChild(desc);
              }
            }
          }

        // PRICE + BUTTON
        const price = el.querySelector(".boost-sd__product-price-wrapper") || el.querySelector(".boost-sd__product-price");

        if (price && !el.querySelector(".custom-footer")) {

          const footer = document.createElement("div");
          footer.className = "custom-footer";

          footer.style.display = "flex";
          footer.style.justifyContent = "space-between";
          footer.style.alignItems = "center";
          footer.style.marginTop = "8px";

          const btn = document.createElement("button");
          btn.innerText = "Add to cart";

          btn.style.border = "1px solid #ff6600";
          btn.style.color = "#ff6600";
          btn.style.borderRadius = "20px";
          btn.style.padding = "5px 12px";
          btn.style.background = "transparent";
          btn.style.cursor = "pointer";

          footer.appendChild(price);
          footer.appendChild(btn);

          const container = el.querySelector(".boost-sd__product-info-wrapper");
          if (container) {
            container.appendChild(footer);
          }
        }

      } // ✅ FIXED closing
    };
  }
};


/* ---------- FORCE SEARCH TEXT CHANGE ---------- */
function forceUpdateSearchText() {
  const el = document.querySelector('.boost-sd__search-result-toolbar-result');
  if (!el) return;

  const total = el.getAttribute('data-total-product') || '';
  const params = new URLSearchParams(window.location.search);
  const query = params.get('q') || '';

  const newText = `${total} RESULTS FOUND FOR "${query.toUpperCase()}"`;

  if (el.innerText !== newText) {
    el.innerText = newText;
  }
}

setInterval(forceUpdateSearchText, 500);